import * as React from 'react'

/**
 * Pins a phone shell to the visual viewport. The on-screen keyboard shrinks
 * `visualViewport` without shrinking `dvh`, so a `h-dvh` composer would sit
 * underneath it. `--app-height` and `--vv-offset-top` track the visible area.
 */
export function useKeyboardInset(active: boolean) {
  React.useEffect(() => {
    if (!active || typeof window === 'undefined') return
    const viewport = window.visualViewport
    if (!viewport) return
    const root = document.documentElement
    const apply = () => {
      root.style.setProperty('--app-height', `${Math.max(0, Math.round(viewport.height))}px`)
      root.style.setProperty('--vv-offset-top', `${Math.max(0, Math.round(viewport.offsetTop))}px`)
    }
    apply()
    viewport.addEventListener('resize', apply)
    viewport.addEventListener('scroll', apply)
    return () => {
      viewport.removeEventListener('resize', apply)
      viewport.removeEventListener('scroll', apply)
      root.style.removeProperty('--app-height')
      root.style.removeProperty('--vv-offset-top')
    }
  }, [active])
}
